import { PortfolioReturnsPeriod } from "@/services/custom-portfolio/custom-portfolio-returns";
import { ChartKey, ChartType } from "@/types/chart";

export const getCustomChartType = ({
  chartKey,
  portfolioReturnsPeriod,
}: {
  chartKey: ChartKey;
  portfolioReturnsPeriod: PortfolioReturnsPeriod;
}): ChartType | undefined => {
  if (chartKey === "custom_portfolio_returns") {
    return portfolioReturnsPeriod === "cumulativeReturns" ? "line" : "bar";
  }
  return undefined;
};
